import React from 'react';
import { X } from 'react-feather';

import { commaThousondSeperator } from '@shared/lib';
import {
  Button,
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  Label,
  SuccessfunbdAward,
} from '@shared/ui';

import { TRedeemRewardResponse } from '../../api';

type TDrawerProps = {
  open: boolean;
  data: TRedeemRewardResponse;
  setOpen: (open: boolean) => void;
};

export const DrawerReward = ({ open, setOpen, data }: TDrawerProps) => {
  return (
    <Drawer
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) setOpen(false);
      }}
    >
      <DrawerContent
        position='bottom'
        className='h-[90vh] max-h-[90vh] overflow-y-auto flex flex-col !p-0'
      >
        <DrawerHeader className='px-5'>
          <div className='flex items-center relative justify-center'>
            <DrawerTitle className='h5-bold '>هدیه صندوق</DrawerTitle>

            <DrawerClose className='absolute left-0 focus-visible:outline-none'>
              <X size={24} strokeWidth={1} />
            </DrawerClose>
          </div>
        </DrawerHeader>

        <div className='flex flex-col gap-[10px] items-center flex-1 px-5'>
          <div className='p-[5px]'>
            <SuccessfunbdAward />
          </div>

          <Label className='h5-bold my-5 text-center'>
            هدیه صندوق با <span className='text-green-1'>موفقیت</span> به شما تعلق گرفت.
          </Label>

          <div className='w-full flex flex-col'>
            <div className='flex justify-between border-y border-border px-2 py-5'>
              <p className='body-12-regular text-text'>صندوق</p>
              <p className='body-12-regular text-text'>{data?.title ?? '-'}</p>
            </div>

            <div className='flex justify-between border-b border-border px-2 py-5'>
              <p className='body-12-regular text-text'>ارزش</p>
              <p className='body-12-regular text-text'>
                {data?.amount !== undefined ? commaThousondSeperator(data.amount) : '-'} ریال
              </p>
            </div>
          </div>
        </div>

        <div className='mt-auto p-5 pt-0 flex flex-col gap-3'>
          <p className='body-12-light text-icons'>
            * صندوق حداکثر تا یک روز کاری بعد، در دارایی شما قابل مشاهده خواهد بود.
          </p>
          <Button
            className='h-[60px] w-full gap-x-1 items-center flex justify-center text-[14px]'
            type='submit'
            onClick={() => setOpen(false)}
          >
            متوجه شدم
          </Button>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
